"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppleAuth = exports.useIsSignedIn = exports.useIsModalOpen = exports.useUser = exports.useIsUserLoading = exports.useIsAuthResolved = exports.default = exports.useAuth = exports.AuthConsumer = exports.AuthProvider = exports.Provider = void 0;
var React = _interopRequireWildcard(require("react"));
var _cookies = require("@kiwicom/cookies");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var api = _interopRequireWildcard(require("./api"));
var session = _interopRequireWildcard(require("../session/session"));
var tokenFns = _interopRequireWildcard(require("./token"));
var _session2 = require("../../consts/session");
var _loadSimpleTokenAuth = _interopRequireDefault(require("./services/loadSimpleTokenAuth"));
var _facebook = require("./services/facebook");
var _google = require("./services/google");
var _waitForVar = _interopRequireDefault(require("../utils/waitForVar"));
var _updateLocale = _interopRequireDefault(require("../../graphql/account/queries/updateLocale"));
var _events = require("../../consts/events");
var _context = require("../log/context");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const contextDefault = {
  auth: null,
  loading: false,
  state: "initial",
  modal: null,
  appleIdToken: null,
  appleUnconfirmedAuthToken: null,
  setAppleIdToken: () => {},
  onOpenModal: () => {},
  onCloseModal: () => {},
  onMyBooking: () => Promise.resolve(),
  onRegister: () => Promise.resolve(),
  onFacebookAuth: () => Promise.resolve(),
  onAppleAuth: () => Promise.resolve({
    connectAccount: false
  }),
  onGoogleAuth: () => Promise.resolve(),
  onSignIn: () => Promise.resolve(),
  onSignOut: () => Promise.resolve(),
  onSetAuth: () => null,
  onGetUserInfoAndLogin: () => Promise.resolve()
};
const context = /*#__PURE__*/React.createContext(contextDefault);
context.displayName = "AuthNitroContext";
const {
  Provider,
  Consumer: AuthConsumer
} = context;
exports.AuthConsumer = AuthConsumer;
exports.Provider = Provider;
const AuthProvider = ({
  children,
  langInfo,
  brand,
  endpoint = api.Endpoint.PLEXUS,
  onMyBooking,
  onSignOut
}) => {
  const [modal, setModal] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState("initial");
  const [auth, setAuth] = React.useState(null);
  const [appleIdToken, setAppleIdToken] = React.useState(null);
  const [appleUnconfirmedAuthToken, setAppleUnconfirmedAuthToken] = React.useState(null);
  const {
    log
  } = (0, _context.useLog)();
  const onSetAuth = React.useCallback(auth => {
    setAuth(auth);
    const cookieSaveOptions = {
      secure: process.env.NODE_ENV !== "development"
    };
    switch (auth.type) {
      case "user":
        tokenFns.save(auth.token);
        break;
      case "token":
        // simple token has sense only when used with bid
        (0, _cookies.save)(_cookies.Cookie.SIMPLE_TOKEN, JSON.stringify(auth), cookieSaveOptions);
        // backward compatibility for old MMB
        _jsCookie.default.set(`simple_token-${auth.bid}`, auth.token, {
          ...cookieSaveOptions,
          expires: new Date(new Date().getTime() + 60 * 60 * 1000) // in 1 hour
        });

        break;
      default:
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const pleaseBeExhaustiveForAuthType = auth;
        throw new Error(`NITRO: Unexpected auth type: ${JSON.stringify(auth)}`);
    }
  }, []);
  const handleUpdateLocale = React.useCallback(auth => {
    if (auth.type === "user") {
      var _user$preferences, _user$preferences2;
      const {
        token,
        user
      } = auth;
      const currencyCookie = (0, _cookies.load)(_cookies.Cookie.CURRENCY);
      const currencyCookieUppercase = typeof currencyCookie === "string" ? currencyCookie.toUpperCase() : null;
      const isUsedLanguageDifferent = langInfo.iso !== ((_user$preferences = user.preferences) === null || _user$preferences === void 0 ? void 0 : _user$preferences.language.isoCode);
      const isUsedCurrencyDifferent = currencyCookieUppercase !== ((_user$preferences2 = user.preferences) === null || _user$preferences2 === void 0 ? void 0 : _user$preferences2.currency.code);
      if (isUsedCurrencyDifferent || isUsedLanguageDifferent) {
        return (0, _updateLocale.default)(token, {
          // Language code passed to mutation must have ISO value
          // language from langInfo contains value of currently used language in browser
          language: {
            code: langInfo.iso
          },
          currency: currencyCookieUppercase
        }).then(() => {
          log(_events.ON_LOGIN_REGIONAL_SETTINGS_UPDATE, {});
        }).catch(err => {
          log(_events.ON_LOGIN_REGIONAL_SETTINGS_ERROR, {
            error: String(err)
          });
        });
      }
    }
    return Promise.resolve();
  }, [langInfo.iso, log]);
  const onGetUserInfoAndLogin = React.useCallback(({
    token,
    shouldUpdateLocale = true
  }) => {
    return api
    // endpoint control here is needed for tequila usecase
    // tequila loads MMB in an iframe and they neeed to call different endpoint
    .getTokenUser(token, endpoint).then(user => ({
      type: "user",
      user,
      token
    })).then(auth => {
      onSetAuth(auth);
      setState("resolved");
      setLoading(false);
      if (shouldUpdateLocale) {
        handleUpdateLocale(auth).catch(() => {});
      }
      return Promise.resolve();
    });
  }, [handleUpdateLocale, onSetAuth, endpoint]);
  React.useEffect(() => {
    const token = tokenFns.load();
    if (token) {
      setState("loading");
      setLoading(true);
      onGetUserInfoAndLogin({
        token,
        shouldUpdateLocale: false
      }).catch(() => {
        setState("resolved");
        setLoading(false);
        tokenFns.remove();
        session.remove(_session2.ACCOUNT_ID);
        session.remove(_session2.EMAIL);
      }).then(() => {
        log(_events.LOGIN_USER_HAS_VALID_TOKEN, {});
      }).catch(err => {
        return Promise.reject(err);
      });
      return;
    }
    setState("resolved");
    const simpleTokenAuth = (0, _loadSimpleTokenAuth.default)();
    if (simpleTokenAuth) {
      setAuth(simpleTokenAuth);
    }
  }, [log, onGetUserInfoAndLogin]);
  const onCloseModal = React.useCallback(() => {
    if (typeof (modal === null || modal === void 0 ? void 0 : modal.onModalClose) === "function") {
      modal.onModalClose();
    }
    setModal(null);
  }, [modal]);
  const clearFbLocalStorage = () => {
    const fbLoginTokenRegex = /^fblst_\d+$/;
    for (const key in localStorage) {
      if (fbLoginTokenRegex.test(key)) {
        localStorage.removeItem(key);
      }
    }
  };
  const handleMyBooking = React.useCallback(input => {
    return api.getMyBookingToken(input).then(res => {
      if (onMyBooking) {
        onMyBooking(res.token);
      } else {
        window.location.assign(`/${langInfo.id}/manage/${res.bid}/${res.token}`);
      }
    }).catch(err => {
      return Promise.reject(err);
    });
  }, [langInfo.id, onMyBooking]);
  const handleRegister = React.useCallback(input => {
    return api.register(brand.id, input).then(() => {}).catch(err => {
      return Promise.reject(err);
    });
  }, [brand.id]);
  const handleGoogleLogin = React.useCallback(() => {
    setState("loading");
    setLoading(true);
    return (0, _google.loginWithGoogleSDK)().then(googleRes => {
      if (googleRes.access_token) {
        return api.googleLogin(googleRes.access_token);
      }
      return Promise.reject(googleRes);
    }).then(res => {
      return onGetUserInfoAndLogin({
        token: res.token
      });
    }).catch(err => {
      return Promise.reject(err);
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
  }, [onGetUserInfoAndLogin]);
  const handleFacebookLogin = React.useCallback(() => {
    setState("loading");
    setLoading(true);
    return (0, _facebook.loginWithFacebookSDK)().then(facebokRes => {
      if (facebokRes.authResponse.accessToken) {
        return api.facebookLogin(facebokRes.authResponse.accessToken);
      }
      return Promise.reject(facebokRes);
    }).then(res => {
      return onGetUserInfoAndLogin({
        token: res.token
      });
    }).catch(err => {
      return Promise.reject(err);
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
  }, [onGetUserInfoAndLogin]);
  const handleAppleLogin = React.useCallback(async () => {
    setState("loading");
    setLoading(true);
    await (0, _waitForVar.default)("AppleID").then(AppleID => {
      if (AppleID == null) {
        return Promise.reject(new Error("AppleID was not initialized."));
      }
      return AppleID.auth.init({
        clientId: "com.kiwi.prod",
        scope: "name email",
        redirectURI: window.origin,
        usePopup: true
      });
    }).catch(err => {
      throw err;
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
    return AppleID.auth.signIn().then(appleRes => {
      if (appleRes.authorization.id_token) {
        setAppleIdToken(appleRes.authorization.id_token);
        return api.appleLogin(appleRes.authorization.id_token);
      }
      return Promise.reject(appleRes);
    }).then(res => {
      // this value represents if user already went through hidden email flow or didn't hide email
      if (!res.is_unconfirmed_private) {
        return onGetUserInfoAndLogin({
          token: res.token
        }).then(() => {
          return {
            connectAccount: false
          };
        });
      }
      setAppleUnconfirmedAuthToken(res.token);
      return {
        connectAccount: true
      };
    }).catch(err => {
      return Promise.reject(err);
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
  }, [onGetUserInfoAndLogin]);
  const handleSignIn = React.useCallback((email, password) => {
    setState("loading");
    setLoading(true);
    return api.signIn({
      email,
      password,
      brand: brand.id
    }, endpoint).then(auth => {
      tokenFns.save(auth.token);
      setState("resolved");
      setLoading(false);
      setAuth(auth);
      return auth;
    }).then(auth => {
      return handleUpdateLocale(auth);
    }).catch(err => {
      setState("resolved");
      setLoading(false);
      return Promise.reject(err);
    });
  }, [handleUpdateLocale, brand.id, endpoint]);
  const handleSignOut = React.useCallback(options => {
    var _options$invokeCallba;
    const invokeCallback = (_options$invokeCallba = options === null || options === void 0 ? void 0 : options.invokeCallback) !== null && _options$invokeCallba !== void 0 ? _options$invokeCallba : true;
    const token = auth === null || auth === void 0 ? void 0 : auth.token;
    session.remove(_session2.ACCOUNT_ID);
    session.remove(_session2.EMAIL);
    tokenFns.remove();
    (0, _cookies.remove)(_cookies.Cookie.SIMPLE_TOKEN);

    // clear out FB login access token from local storage
    clearFbLocalStorage();
    if ((auth === null || auth === void 0 ? void 0 : auth.type) === "token" && auth.bid) {
      _jsCookie.default.remove(`simple_token-${auth.bid}`);
    }
    setAuth(null);
    if (onSignOut && invokeCallback) {
      onSignOut();
    }
    if (token) {
      return api.logout(token);
    }
    return Promise.resolve();
  }, [onSignOut, auth]);
  const onOpenModal = React.useCallback(options => setModal(options || {}), []);
  const contextValue = React.useMemo(() => ({
    auth,
    loading,
    state,
    onMyBooking: handleMyBooking,
    onRegister: handleRegister,
    onFacebookAuth: handleFacebookLogin,
    onAppleAuth: handleAppleLogin,
    onGoogleAuth: handleGoogleLogin,
    onSignIn: handleSignIn,
    onSignOut: handleSignOut,
    setAppleIdToken,
    modal,
    appleIdToken,
    appleUnconfirmedAuthToken,
    onCloseModal,
    onOpenModal,
    onSetAuth,
    onGetUserInfoAndLogin
  }), [auth, handleMyBooking, appleIdToken, appleUnconfirmedAuthToken, handleRegister, handleSignIn, handleSignOut, handleFacebookLogin, handleGoogleLogin, setAppleIdToken, loading, state, modal, onCloseModal, onOpenModal, onSetAuth, handleAppleLogin, onGetUserInfoAndLogin]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: contextValue,
    children: children
  });
};
exports.AuthProvider = AuthProvider;
const useAuth = () => React.useContext(context);
exports.useAuth = useAuth;
var _default = context;
exports.default = _default;
const useIsAuthResolved = () => {
  const {
    state
  } = useAuth();
  return state === "resolved";
};
exports.useIsAuthResolved = useIsAuthResolved;
const useIsUserLoading = () => {
  const {
    loading
  } = useAuth();
  return loading;
};
exports.useIsUserLoading = useIsUserLoading;
const useUser = () => {
  const {
    auth
  } = useAuth();
  return (auth === null || auth === void 0 ? void 0 : auth.type) === "user" ? auth.user : null;
};
exports.useUser = useUser;
const useIsModalOpen = () => {
  const {
    modal
  } = useAuth();
  return modal !== null;
};
exports.useIsModalOpen = useIsModalOpen;
const useIsSignedIn = () => {
  const {
    auth
  } = useAuth();
  return (auth === null || auth === void 0 ? void 0 : auth.type) === "user";
};
exports.useIsSignedIn = useIsSignedIn;
const useAppleAuth = () => {
  const {
    appleIdToken,
    appleUnconfirmedAuthToken
  } = useAuth();
  return {
    appleIdToken,
    appleUnconfirmedAuthToken
  };
};
exports.useAppleAuth = useAppleAuth;